export default {
  // ===== 充值/訂單管理共享（RechargeManage + OrderLedger）=====
  'pages.billing.bizVoiceClone': '音色克隆',
  'pages.billing.bizSim': '4G 流量充值',
  'pages.billing.bizVoiceCloneQuota': '音色克隆次數包',

  'pages.billing.saved': '已儲存',
  'pages.billing.saveFail': '儲存失敗',
  'pages.billing.deleted': '已刪除',
  'pages.billing.detailLoadFail': '載入詳情失敗',
  'pages.billing.retryTriggered': '已觸發重試',
  'pages.billing.wechatRefundStarted': '已發起微信原路退款',

  'pages.billing.colCode': '編碼',
  'pages.billing.colName': '名稱',
  'pages.billing.colEnabled': '啟用',
  'pages.billing.colSort': '排序',
  'pages.billing.colActions': '操作',
  'pages.billing.colProvider': '提供商',
  'pages.billing.colPackageName': '套餐名',
  'pages.billing.colPlatformCode': '平臺編碼',
  'pages.billing.colUseTypeField': '用 type 欄位',
  'pages.billing.colUserPrice': '使用者價(元)',
  'pages.billing.colCostPrice': '成本價(元)',
  'pages.billing.colOrderNo': '訂單號',
  'pages.billing.colType': '型別',
  'pages.billing.colBizType': '業務型別',
  'pages.billing.colUserId': '使用者ID',
  'pages.billing.colDeviceId': '裝置ID',
  'pages.billing.colAmount': '金額(元)',
  'pages.billing.colFee': '手續費(元)',
  'pages.billing.colStatus': '狀態',
  'pages.billing.colRefundStatus': '退款狀態',
  'pages.billing.colCreatedAt': '建立時間',
  'pages.billing.colCompletedAt': '完成時間',
  'pages.billing.colPayChannel': '支付渠道',

  'pages.billing.yes': '是',
  'pages.billing.no': '否',
  'pages.billing.edit': '編輯',
  'pages.billing.delete': '刪除',
  'pages.billing.confirmDelete': '確定刪除？',
  'pages.billing.detail': '詳情',
  'pages.billing.retryRecharge': '重試充值',
  'pages.billing.wechatRefund': '微信退款',
  'pages.billing.usedNoRefund': '已消耗次數不可退',
  'pages.billing.retryConfirm': '確認對該訂單再次發起物聯充值？（已向平臺下發過的訂單不可重試）',
  'pages.billing.wechatRefundConfirm': '確認發起微信全額原路退款？退款到賬時間以微信為準。',

  'pages.billing.tabProviders': '物聯卡提供商',
  'pages.billing.tabPackages': '充值套餐',
  'pages.billing.tabOrders': '充值訂單',
  'pages.billing.newProvider': '新建提供商',
  'pages.billing.newPackage': '新建套餐',
  'pages.billing.refresh': '重新整理',
  'pages.billing.query': '查詢',
  'pages.billing.filterOrderType': '訂單型別',
  'pages.billing.all': '全部',
  'pages.billing.optional': '可選',
  'pages.billing.orderNoFuzzy': '訂單號（模糊）',

  'pages.billing.statusPending': '待支付',
  'pages.billing.statusPaid': '已支付',
  'pages.billing.statusRecharging': '充值中',
  'pages.billing.statusDone': '已完成',
  'pages.billing.statusFailed': '失敗',
  'pages.billing.statusCancelled': '已取消',

  'pages.billing.rechargeManageTitle': '流量卡充值管理',
  'pages.billing.orderLedgerTitle': '訂單臺賬',
  'pages.billing.editProvider': '編輯提供商',
  'pages.billing.uniqueCode': '唯一編碼',
  'pages.billing.required': '必填',
  'pages.billing.requiredSelect': '必選',
  'pages.billing.providerCodePlaceholder': '如 wanweilOT，需與服務端 recharge.sim_platforms 配置鍵一致',
  'pages.billing.editPackage': '編輯套餐',
  'pages.billing.selectProvider': '選擇提供商',
  'pages.billing.packageName': '套餐名稱',
  'pages.billing.platformPackageCode': '平臺套餐編碼 (pcode/type)',
  'pages.billing.platformPackageCodePlaceholder': '一級代理平臺套餐編碼',
  'pages.billing.useTypeFieldLabel': '使用 type 欄位（否則用 pcode）',
  'pages.billing.userPriceYuan': '使用者售價(元)',
  'pages.billing.platformCostYuan': '平臺成本價(元)',
  'pages.billing.onShelf': '上架',

  'pages.billing.orderDetailTitle': '訂單詳情',
  'pages.billing.loading': '載入中…',
  'pages.billing.secOrderPay': '訂單與支付',
  'pages.billing.secDevice': '裝置',
  'pages.billing.secSimCardSnapshot': '物理網絡卡（快照）',
  'pages.billing.secPackage': '套餐',
  'pages.billing.dWechatTradeNo': '微信交易號',
  'pages.billing.dPaidAt': '支付時間',
  'pages.billing.dFailedReason': '失敗原因',
  'pages.billing.dRechargeError': '物聯充值錯誤',
  'pages.billing.dRefundedAt': '退款時間',
  'pages.billing.dQuotaTotal': '購買次數',
  'pages.billing.dQuotaUsed': '已消耗次數',
  'pages.billing.dRemaining': '剩餘次數',
  'pages.billing.dDevId': '裝置 ID',
  'pages.billing.dDevName': '裝置名稱',
  'pages.billing.dIotSCode': '物聯卡號',
  'pages.billing.dPlatformOrder': '平臺訂單號',
  'pages.billing.dPkgId': '套餐 ID',
  'pages.billing.dPrice': '售價(元)',
  'pages.billing.total': '共 {count} 條',

  // ===== SimRecharge（Web 控制檯）本次新建 =====
  'pages.simRecharge.notice.heading': '購前須知',
  'pages.simRecharge.notice.sec1Title': '一、免責與風險提示',
  'pages.simRecharge.notice.sec1Body':
    '您理解並同意：4G 流量套餐充值依賴裝置、運營商及第三方平臺系統，可能受網路波動、資費策略、維護視窗、卡狀態等因素影響。「{platform}」將在合理範圍內為您辦理充值，但不對特定到賬時刻、平臺展示與運營商側資料偶發不一致、以及不可抗力造成的損失承擔超出法律法規要求以外的責任。請付款前再次核對所選<b>裝置與 ICCID、套餐名稱與金額</b>，確認無誤後再支付。',
  'pages.simRecharge.notice.sec2Title': '二、退款規則',
  'pages.simRecharge.notice.sec2p1':
    '（1）<b>充值失敗</b>：若支付後訂單最終判定為充值失敗，已支付款項將按<b>微信支付原路退回</b>。實際路徑以微信及訂單狀態為準：可能由系統自動完成退款，也可能需要您在「我的訂單」中對失敗單<b>手動申請</b>原路退款；請留意訂單狀態與微信賬單。',
  'pages.simRecharge.notice.sec2p2':
    '（2）<b>充值成功</b>：當訂單顯示充值已完成且套餐已下發或已生效後，本服務屬於已履行的數字化/通訊類消費，<b>不支援退款</b>，請在下單前謹慎選擇。',
  'pages.simRecharge.notice.sec3Title': '三、其他',
  'pages.simRecharge.notice.sec3Body':
    '本須知作為《使用者協議》的補充；如有不一致，以《使用者協議》及頁面公示為準。如有疑問，請透過應用內公示的客服渠道聯絡。',

  'pages.simRecharge.platformDefault': '本平臺',
  'pages.simRecharge.loadPkgFail': '載入套餐失敗',
  'pages.simRecharge.deviceLabel': '裝置 #{id}',
  'pages.simRecharge.prefillInvalid': '連結中的裝置或物理網絡卡無效，請在下拉框中手動選擇。',
  'pages.simRecharge.done': '充值已完成',
  'pages.simRecharge.rechargeFailed': '充值失敗',
  'pages.simRecharge.cancelled': '訂單已取消',
  'pages.simRecharge.statusFallback': '狀態 {st}',
  'pages.simRecharge.selectDevicePkg': '請選擇裝置與套餐',
  'pages.simRecharge.orderFail': '下單失敗',
  'pages.simRecharge.noCodeUrl': '未獲取到付款碼，請確認服務端已開通微信 Native 支付',
  'pages.simRecharge.cancelSent': '已嘗試取消待支付訂單（若已支付請忽略）',
  'pages.simRecharge.loadOrdersFail': '載入訂單失敗',
  'pages.simRecharge.disabled': '當前環境未開啟流量卡充值或微信支付，請聯絡管理員。',
  'pages.simRecharge.scanHint': '請使用本人微信掃描付款碼完成支付；支付成功後頁面將自動重新整理結果。',
  'pages.simRecharge.prefillBanner': '已從裝置管理帶入：{device}，物理網絡卡 ICCID：{iccid}',
  'pages.simRecharge.tab.recharge': '去充值',
  'pages.simRecharge.tab.orders': '我的訂單',
  'pages.simRecharge.selectDeviceLabel': '選擇裝置（需已上報 ICCID）',
  'pages.simRecharge.selectDevicePlaceholder': '請選擇裝置',
  'pages.simRecharge.deviceFallback': '裝置',
  'pages.simRecharge.selectPackageLabel': '選擇套餐',
  'pages.simRecharge.selectPackagePlaceholder': '請選擇套餐',
  'pages.simRecharge.selectDeviceFirst': '請先選擇裝置',
  'pages.simRecharge.genPayCode': '生成微信付款碼',
  'pages.simRecharge.orderStatusPending': '待支付',
  'pages.simRecharge.orderStatusPaid': '已支付',
  'pages.simRecharge.orderStatusRecharging': '充值中',
  'pages.simRecharge.orderStatusDone': '已完成',
  'pages.simRecharge.orderStatusFailed': '充值失敗',
  'pages.simRecharge.orderStatusCancelled': '已取消',
  'pages.simRecharge.filterStatus': '訂單狀態',
  'pages.simRecharge.filterStatusAll': '全部',
  'pages.simRecharge.filterOrderNo': '訂單號（模糊）',
  'pages.simRecharge.filterQuery': '查詢',
  'pages.simRecharge.noticeModalTitle': '4G 流量充值 — 購前須知',
  'pages.simRecharge.noticeAgree': '我已閱讀並理解上述須知（含免責與退款規則）',
  'pages.simRecharge.agreeAndGenPayCode': '同意並生成付款碼',
  'pages.simRecharge.wechatScanTitle': '微信掃碼支付',
  'pages.simRecharge.closeAndCancel': '關閉並取消待支付',
  'pages.simRecharge.payOrderInfo': '訂單 {no}，應付 ¥{amount}',
};
